/* eslint-disable max-statements */
import { createSelector } from 'reselect';
import { isValidCalculationControl, ctrlDefaults, isValidCalculationResultControl } from '../../../shared/form-lib';
import { fplsConstants } from '../../../shared/constants';
import { truncText } from '../../../shared/utils';

export const selectbuilderForm = (state) => state.builder.present.builderForm;

const selectPages = createSelector([selectbuilderForm], (builderForm) => builderForm.pages);

export const selectPageControlIds = createSelector([selectbuilderForm], (builderForm) => builderForm.pageIds);

export const selectFormCalculations = createSelector([selectbuilderForm], (builderForm) => builderForm.calculations);

const selectOperands = createSelector([selectFormCalculations], (calculations) => {
  let operandsArray = [];
  calculations.forEach((calculation) => {
    operandsArray = operandsArray.concat(calculation.operands);
  });
  return operandsArray;
});

export const selectCalculationResultList = createSelector([selectFormCalculations], (calculations) => {
  const calculationResultsList = [];
  calculations.forEach((calculation) => {
    calculationResultsList.push(calculation.result);
  });
  return calculationResultsList;
});

export const selectRowControls = (state) => state.builder.present.addRowCtrls;

export const selectCalculationFields = createSelector(
  [selectPages, selectPageControlIds, selectCalculationResultList, selectOperands, selectRowControls],
  (pages, pageIds, calculationResultsList, allOperands, addRowCtrls) => {
    let rowCtrl;
    const formFieldsList = [];
    const formFieldsTableList = [];
    const formCalculationResultList = [];
    const ctrlIndex = {};

    for (let i = 0; i < pages.length; i += 1) {
      for (let j = 0; j < pageIds[i].length; j += 1) {
        const fieldId = pageIds[i][j];
        const ctrl = pages[i][Number(fieldId)];
        if (!ctrl.is_row) {
          const rightCtrlType = isValidCalculationControl(ctrl);
          if (ctrl.props.controls) {
            for (let rowCtrlId = 0; rowCtrlId < ctrl.props.controls.length; rowCtrlId += 1) {
              rowCtrl = addRowCtrls[ctrl.props.controls[rowCtrlId]];
              if (rowCtrl) {
                const rightRowCtrlType = isValidCalculationControl(rowCtrl);
                if (rightRowCtrlType) {
                  formFieldsList.push({
                    id: rowCtrl.internal_id,
                    label: rowCtrl.props.label || ctrlDefaults()[rowCtrl.type],
                    type: rowCtrl.type,
                  });
                }
              }
            }
          }
          if (rightCtrlType) {
            if (ctrl.type !== 'table_field') {
              formFieldsList.push({
                id: ctrl.internal_id,
                label: ctrl.props.label || ctrlDefaults()[ctrl.type],
                type: ctrl.type,
              });
            } else {
              const formField = {
                id: ctrl.internal_id,
                label: ctrl.props.label || ctrlDefaults()[ctrl.type],
                type: ctrl.type,
                columns: [],
              };
              for (let x = 0; x < ctrl.props.column_headers.length; x += 1) {
                const header = ctrl.props.column_headers[x];
                const ctrlAllowed = isValidCalculationControl({
                  type: ctrl.props.column_types[x],
                  props: { type: '' },
                });
                if (ctrlAllowed) {
                  formField.columns.push({
                    idx: x,
                    header,
                  });
                }
              }
              formFieldsList.push(formField);
              ctrl.props.column_headers.forEach((header, idx) => {
                const allowedCtrl = isValidCalculationControl({
                  type: ctrl.props.column_types[idx],
                  props: { type: '' },
                });
                if (allowedCtrl) {
                  formFieldsTableList.push({
                    id: ctrl.internal_id,
                    label: ctrl.props.label
                      ? `${ctrl.props.label} - ${header}`
                      : `${ctrlDefaults()[ctrl.type]} - ${header}`,
                    index: idx,
                    type: ctrl.type,
                  });
                }
              });
            }
          }
          if (isValidCalculationResultControl(ctrl)) {
            if (ctrl.type === 'table_field') {
              ctrl.props.column_types.forEach((columnType, idx) => {
                if (
                  fplsConstants.CALCULATION_CONTROL_RESULT_LIST.indexOf(columnType) !== -1 &&
                  !calculationResultsList.includes(`${ctrl.internal_id}_${idx}`)
                ) {
                  formCalculationResultList.push({
                    id: `${ctrl.internal_id}_${idx.toString()}`,
                    label: `${truncText(ctrl.props.label, 30)}: ${ctrl.props.column_headers[idx]}`,
                  });
                }
              });
            } else if (!calculationResultsList.includes(ctrl.internal_id)) {
              formCalculationResultList.push({
                id: ctrl.internal_id,
                label: ctrl.props.label || ctrlDefaults()[ctrl.type],
              });
            }
          } else if (ctrl.props.controls) {
            ctrl.props.controls.forEach((control) => {
              const resultRowCtrl = addRowCtrls[control];
              if (resultRowCtrl) {
                if (
                  isValidCalculationResultControl(resultRowCtrl) &&
                  !calculationResultsList.includes(resultRowCtrl.internal_id) &&
                  !allOperands.includes(resultRowCtrl.internal_id)
                ) {
                  formCalculationResultList.push({
                    id: control,
                    label: resultRowCtrl.props.label || ctrlDefaults()[resultRowCtrl.type],
                  });
                }
              }
              ctrlIndex[control] = addRowCtrls[control];
            });
          }
          ctrlIndex[ctrl.internal_id] = ctrl;
        }
      }
    }

    return { formFieldsList, formFieldsTableList, formCalculationResultList, ctrlIndex };
  }
);

const selectControl = (state, control) => control;
export const fieldIsCalculation = createSelector(
  [selectControl, selectCalculationResultList],
  (control, resultList) => {
    return resultList.includes(control.internal_id);
  }
);
